// Aurea Theme Global JS

// Wishlist Functionality
const WISHLIST_KEY = 'aurea_wishlist';

// Global function to toggle wishlist (called by onclick in liquid)
window.toggleWishlist = function(btn) {
  const handle = btn.dataset.productHandle;
  if (!handle) return;

  let wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
  
  if (wishlist.includes(handle)) {
    // Remove from wishlist
    wishlist = wishlist.filter(item => item !== handle);
    btn.classList.remove('active');
  } else {
    // Add to wishlist
    wishlist.push(handle);
    btn.classList.add('active');
  }
  
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
  
  // Sync all other buttons for the same product handle
  updateWishlistIcons(handle);
};

// Sync UI icons with localStorage state
function updateWishlistIcons(specificHandle = null) {
  const wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
  const wishlistButtons = document.querySelectorAll('.js-wishlist-btn');
  
  wishlistButtons.forEach(btn => {
    const handle = btn.dataset.productHandle;
    
    // If we are updating only one product, skip others
    if (specificHandle && handle !== specificHandle) return;

    if (wishlist.includes(handle)) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // Sync icons on page load
  updateWishlistIcons();
});

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const targetId = this.getAttribute('href');
    
    if (targetId === "#") return;

    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      e.preventDefault();

      const offset = 100; 

      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      
      // Aggiorna l'URL senza far saltare la pagina
      history.pushState(null, null, targetId);
    }
  });
});